import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { IndexDaily, fetchLogo } from "../../Api";
import LoadingSpinner from "../../components/Loading";

import {
    Container,
    HeaderWrapper,
    ContInfo,
    //AttendanceContainer,
    LessonsContainer,
    GradesTableContainer,
    ConceptsTableContainer,
    AssessmentsContainer,
    CtnrBtt,
    ButtonPrint,
    Preview,
    AttendanceWrapper,
    AttendanceCard,
    CardHeader,
    StyledTable,
} from "./style";

export default function ReportDaily() {
    const { id_class, idBimonthly, bimonthly } = useParams();
    const decodedBimonthly = decodeURIComponent(bimonthly);

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [logoUrl, setLogoUrl] = useState("");

    useEffect(() => {
        (async () => {
            setLoading(true);

            const idSchool = JSON.parse(sessionStorage.getItem("id-school"));

            // 🔹 LOGO
            const cachedLogo = localStorage.getItem(`school-logo-${idSchool}`);
            if (cachedLogo) {
                setLogoUrl(cachedLogo);
            } else {
                const logoRes = await fetchLogo(idSchool);
                if (logoRes?.url) {
                    setLogoUrl(logoRes.url);
                }
            }

            // 🔹 PARAMS DINÂMICOS
            const params = { idClass: id_class };

            if (decodedBimonthly === "1º BIMESTRE") params.id_iStQuarter = idBimonthly;
            if (decodedBimonthly === "2º BIMESTRE") params.id_iiNdQuarter = idBimonthly;
            if (decodedBimonthly === "3º BIMESTRE") params.id_iiiRdQuarter = idBimonthly;
            if (decodedBimonthly === "4º BIMESTRE") params.id_ivThQuarter = idBimonthly;
            const res = await IndexDaily(params);
            setData(res.data.dailies[0]);

            setLoading(false);
        })();
    }, [id_class, idBimonthly, bimonthly, decodedBimonthly]);

    const handlePrint = () => window.print();

    if (loading) return <LoadingSpinner />;

    const getStudentAttendance = (studentId, attendanceArray) => {
        let P = 0, F = 0, FJ = 0;

        attendanceArray?.forEach((att) => {
            if (att.id_student === studentId) {
                if (att.status === "P") P++;
                if (att.status === "F") F++;
                if (att.status === "FJ") FJ++;
            }
        });

        return { P, F, FJ };
    };

    const activeStudents = data.id_student || [];
    const transferredStudents = data.transferStudents || [];

    console.log("data", data)
    return (
        <Container>

            {/* 🔹 BOTÃO */}
            <CtnrBtt className="no-print">
                <ButtonPrint onClick={handlePrint}>Imprimir Relatório</ButtonPrint>
            </CtnrBtt>

            {/* 🔹 CABEÇALHO */}
            <HeaderWrapper>
                {logoUrl && <Preview src={logoUrl} alt="Logo" />}

                <ContInfo>
                    <h2>RELATÓRIO DE FECHAMENTO DO DIÁRIO</h2>
                    <span><strong>Escola:</strong> {data.nameSchool}</span>
                    <span><strong>Série:</strong> {data.serie}</span>
                    <span><strong>Turma:</strong> {data.nameClass}</span>
                    <span><strong>Ano:</strong> {data.year}</span>
                    <span><strong>Bimestre:</strong> {data.bimonthly}</span>
                    <span><strong>Professor:</strong> {data.nameRegentTeacher}</span>
                </ContInfo>
            </HeaderWrapper>

            {/* ===================== FREQUÊNCIA ===================== */}
            <AttendanceWrapper>

                {/* ================= REGENTE ================= */}
                <AttendanceCard>
                    <CardHeader>
                        <h2>Frequência</h2>
                        <span>Professor Regente: {data.nameRegentTeacher}</span>
                    </CardHeader>

                    <StyledTable>
                        <thead>
                            <tr>
                                <th>Aluno</th>
                                <th>P</th>
                                <th>F</th>
                                <th>FJ</th>
                            </tr>
                        </thead>

                        <tbody>

                            {/* 🔹 ATIVOS */}
                            {activeStudents.map((student) => {
                                const { P, F, FJ } = getStudentAttendance(
                                    student._id,
                                    data.attendance
                                );

                                return (
                                    <tr key={student._id}>
                                        <td>{student.name}</td>
                                        <td>{P}</td>
                                        <td>{F}</td>
                                        <td>{FJ}</td>
                                    </tr>
                                );
                            })}

                            {/* 🔥 TRANSFERIDOS */}
                            {transferredStudents.length > 0 && (
                                <>
                                    <tr>
                                        <td colSpan="4" className="section-divider" style={{color: '#e08a0b'}}>
                                            Alunos Transferidos
                                        </td>
                                    </tr>

                                    {transferredStudents.map((student) => {
                                        const { P, F, FJ } = getStudentAttendance(
                                            student._id,
                                            data.attendance
                                        );

                                        return (
                                            <tr key={student._id} className="row-transferred">
                                                <td>
                                                    {student.name}
                                                    <span className="tag-transferido" style={{color: '#e08a0b'}}>(Transferido)</span>
                                                </td>
                                                <td>{P}</td>
                                                <td>{F}</td>
                                                <td>{FJ}</td>
                                            </tr>
                                        );
                                    })}
                                </>
                            )}

                        </tbody>
                    </StyledTable>
                </AttendanceCard>


                {/* ================= EDUCAÇÃO FÍSICA ================= */}
                <AttendanceCard>
                    <CardHeader>
                        <h2>Frequência</h2>
                        <span>Ed. Física: {data.namephysicalEducationTeacher}</span>
                    </CardHeader>

                    <StyledTable>
                        <thead>
                            <tr>
                                <th>Aluno</th>
                                <th>P</th>
                                <th>F</th>
                                <th>FJ</th>
                            </tr>
                        </thead>

                        <tbody>

                            {/* 🔹 ATIVOS */}
                            {activeStudents.map((student) => {
                                const { P, F, FJ } = getStudentAttendance(
                                    student._id,
                                    data.attendancePhysicalEducationTeacher // ✅ CORRETO
                                );

                                return (
                                    <tr key={student._id}>
                                        <td>{student.name}</td>
                                        <td>{P}</td>
                                        <td>{F}</td>
                                        <td>{FJ}</td>
                                    </tr>
                                );
                            })}

                            {/* 🔥 TRANSFERIDOS */}
                            {transferredStudents.length > 0 && (
                                <>
                                    <tr>
                                        <td colSpan="4" className="section-divider" style={{color: '#e08a0b'}}>
                                            Alunos Transferidos
                                        </td>
                                    </tr>

                                    {transferredStudents.map((student) => {
                                        const { P, F, FJ } = getStudentAttendance(
                                            student._id,
                                            data.attendancePhysicalEducationTeacher // ✅ CORRETO
                                        );

                                        return (
                                            <tr key={student._id} className="row-transferred">
                                                <td>
                                                    {student.name}
                                                    <span className="tag-transferido" style={{color: '#e08a0b'}}>(Transferido)</span>
                                                </td>
                                                <td>{P}</td>
                                                <td>{F}</td>
                                                <td>{FJ}</td>
                                            </tr>
                                        );
                                    })}
                                </>
                            )}

                        </tbody>
                    </StyledTable>
                </AttendanceCard>

            </AttendanceWrapper>

            {/* ===================== AULAS ===================== */}
            <LessonsContainer>
                <h2>Aulas Lecionadas</h2>

                {data.id_recordClassTaught?.map((aula, i) => (
                    <div key={i}>
                        <strong>{`${aula.day}/${aula.month}/${aula.year}`}</strong>
                        <div dangerouslySetInnerHTML={{ __html: aula.description }} />
                    </div>
                ))}
            </LessonsContainer>

            {/* ===================== AVALIAÇÕES ===================== */}
            <AssessmentsContainer>
                <h2>Avaliações</h2>

                {data.idActivity?.map((act, i) => (
                    <div key={i}>
                        <p><strong>Disciplina:</strong> {act?.id_matter?.name}</p>
                        <p>{act.descricao}</p>
                    </div>
                ))}
            </AssessmentsContainer>

            {/* ===================== NOTAS ===================== */}
            <GradesTableContainer>
                <h2>Notas</h2>

                <table>
                    <thead>
                        <tr>
                            <th>Aluno</th>
                            <th>Disciplina</th>
                            <th>Nota</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.studentGrade?.map((g, i) => (
                            <tr key={i}>
                                <td>{g?.id_student?.name}</td>
                                <td>{g?.id_matter?.name}</td>
                                <td>{g.studentGrade}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </GradesTableContainer>

            {/* ===================== CONCEITOS ===================== */}
            {data.studentConcept && (
                <ConceptsTableContainer>
                    <h2>Conceitos</h2>

                    <table>
                        <thead>
                            <tr>
                                <th>Aluno</th>
                                <th>Disciplina</th>
                                <th>Conceito</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data.studentConcept.map((c, i) => (
                                <tr key={i}>
                                    <td>{c?.id_student?.name}</td>
                                    <td>{c?.id_matter?.name}</td>
                                    <td>{c.studentGrade}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </ConceptsTableContainer>
            )}

        </Container>
    );
}